import { render, staticRenderFns } from "./GenericSelfService.vue?vue&type=template&id=2c36802e&scoped=true&"
import script from "./GenericSelfService.vue?vue&type=script&lang=js&"
export * from "./GenericSelfService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c36802e",
  null
  
)

export default component.exports